
 export const professionList= [
     {
      "ID": 1,
      "Profession": "Financial Advisor",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 2,
      "Profession": "Insurance Agent",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 3,
      "Profession": "Equity Analyst",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 4,
      "Profession": "Mutual Fund Advisor",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    // {
    //   "ID": 5,
    //   "Profession": "Financial Manager",
    //   "IsActive": true,
    //   "CreatedBy": null,
    //   "CreatedOn": null,
    //   "ModifiedBy": null,
    //   "ModifiedOn": null
    // },
    {
      "ID": 5,
      "Profession": "Trainer",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 6,
      "Profession": "Investment Advisor ",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 7,
      "Profession": "Student",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 8,
      "Profession": "Business",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 9,
      "Profession": "Private Sector",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    },
    {
      "ID": 10,
      "Profession": "Other",
      "IsActive": true,
      "CreatedBy": null,
      "CreatedOn": null,
      "ModifiedBy": null,
      "ModifiedOn": null
    }
  ]
